export const accountHomeViewConstants = {
  APPLIANCES_REQUEST: "APPLIANCES_REQUEST",
  APPLIANCES_SUCCESS: "APPLIANCES_SUCCESS",
  APPLIANCES_FAILURE: "APPLIANCES_FAILURE",
  GET_APPLIANCE_REQUEST: "GET_APPLIANCE_REQUEST",
  GET_APPLIANCE_SUCCESS: "GET_APPLIANCE_SUCCESS",
  GET_APPLIANCE_FAILURE: "GET_APPLIANCE_FAILURE",
  SET_APPLIANCE_REQUEST: "SET_APPLIANCE_REQUEST",
  SET_APPLIANCE_SUCCESS: "SET_APPLIANCE_SUCCESS",
  SET_APPLIANCE_FAILURE: "SET_APPLIANCE_FAILURE",
  GET_HOLIDAY_MODE_REQUEST: "GET_HOLIDAY_MODE_REQUEST",
  GET_HOLIDAY_MODE_SUCCESS: "GET_HOLIDAY_MODE_SUCCESS",
  GET_HOLIDAY_MODE_FAILURE: "GET_HOLIDAY_MODE_FAILURE",
  SET_HOLIDAY_MODE_REQUEST: "SET_HOLIDAY_MODE_REQUEST",
  SET_HOLIDAY_MODE_SUCCESS: "SET_HOLIDAY_MODE_SUCCESS",
  SET_HOLIDAY_MODE_FAILURE: "SET_HOLIDAY_MODE_FAILURE",
  GET_DO_NOT_DISTURB_REQUEST: "GET_DO_NOT_DISTURB_REQUEST",
  GET_DO_NOT_DISTURB_SUCCESS: "GET_DO_NOT_DISTURB_SUCCESS",
  GET_DO_NOT_DISTURB_FAILURE: "GET_DO_NOT_DISTURB_FAILURE",
  SET_DO_NOT_DISTURB_REQUEST: "SET_DO_NOT_DISTURB_REQUEST",
  SET_DO_NOT_DISTURB_SUCCESS: "SET_DO_NOT_DISTURB_SUCCESS",
  SET_DO_NOT_DISTURB_FAILURE: "SET_DO_NOT_DISTURB_FAILURE",
  GET_TARIFF_REQUEST: "GET_TARIFF_REQUEST",
  GET_TARIFF_SUCCESS: "GET_TARIFF_SUCCESS",
  GET_TARIFF_FAILURE: "GET_TARIFF_FAILURE",
  SET_TARIFF_REQUEST: "SET_TARIFF_REQUEST",
  SET_TARIFF_SUCCESS: "SET_TARIFF_SUCCESS",
  SET_TARIFF_FAILURE: "SET_TARIFF_FAILURE",
};
